import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/free-regular-svg-icons';
import { Image, Text } from '@ui/atoms';
import PropTypes from 'prop-types';

const DetailValue = ({ value, showCopy, copySuccess, onCopy }) => (
    <div className="flex items-center whitespace-nowrap">
        <Text
            content={
                <>
                    {value}
                    {showCopy && (
                        <span
                            onClick={onCopy}
                            className="ml-1 cursor-pointer flex-center"
                        >
                            {copySuccess === value ? (
                                <FontAwesomeIcon
                                    className="inline-block text-semantic-success-base w-4 h-4 xl:w-6 xl:h-6"
                                    icon={faCheckCircle}
                                />
                            ) : (
                                <Image
                                    src="/icons/CopyWhite.svg"
                                    className="inline w-4 h-4 xl:w-6 xl:h-6"
                                    alt="copy"
                                />
                            )}
                        </span>
                    )}
                </>
            }
            className="p4-medium md:p3-semibold flex-center"
        />
    </div>
);

DetailValue.propTypes = {
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
    showCopy: PropTypes.bool,
    copySuccess: PropTypes.string,
    onCopy: PropTypes.func,
};

export default DetailValue;
